module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixedChangeBox"
  }, [_c('div', {
    staticClass: "changeBox"
  }, [_c('div', {
    staticClass: "mianBox clearfix",
    class: {
      small: _vm.size == 'small'
    }
  }, [_c('div', {
    staticClass: "leftBox",
    class: {
      active: _vm.checked == true
    },
    on: {
      "click": function($event) {
        return _vm.change()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title1))])]), _vm._v(" "), _c('div', {
    staticClass: "rightBox",
    class: {
      active: _vm.checked == false
    },
    on: {
      "click": function($event) {
        return _vm.change()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title2))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-875f731a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/switch.vue
// module id = 1813
// module chunks = 107